import { Component, OnInit } from '@angular/core';

import {
  ApplicationApiService,
  AuthenticationService, 
  ContactApiService,
  CrossSiteNavigationService
} from '../data-services/index';

import {
  IContact, IUser, IHelp, HelpApiService, AppLoadService, IApplication
} from '@ebb-v2/ebb-integration';
import { Router } from '@angular/router';

@Component({
  selector: 'ebb-portal-training',
  templateUrl: './training.component.html'
})
export class TrainingComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public listHelp: IHelp[] = [];

  public textFemaTrainingContractor: string;
  public textFemaTrainingHomeowner: string;
  public textEssFemaTrainingHomeowner: string;
  public showFemaTrainingHomeowner: boolean;
  public showEssFemaTrainingHomeowner: boolean;
  public textContractorResources: string;
  public ebbTrainingUrl: string;
  public essTrainingUrl: string;
  public trainingUrl: string;
public applications: IApplication[] = [];

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly apiContact: ContactApiService,
    private readonly appLoadService: AppLoadService,
    private readonly xSiteNavServie: CrossSiteNavigationService,
    private readonly apiApplication: ApplicationApiService,
    private apiHelp: HelpApiService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getContact(this.currentUser.id);
    this.loadHelpText();

   

  }

  private getContact(currentId: string): void {
    this.apiContact
      .getContact(currentId)
      .subscribe(
        data => {
         this.currentContact = data;
     
        },
        error => console.warn(`ERROR: Training.getContact() - ${error}`)
      )
  }

  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = [...data];
          const indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'contractorfematraining');
          if (indexHelpContractor >= 0)
            this.textFemaTrainingContractor = this.listHelp[indexHelpContractor].answer;
          const indexContractorResources = this.listHelp.findIndex(i => i.name.toLowerCase() === 'contractorresources');
          if (indexContractorResources >= 0)
            this.textContractorResources = this.listHelp[indexContractorResources].answer;
          const indexHelpHomeowner = this.listHelp.findIndex(i => i.name.toLowerCase() === 'homeownerfematraining');
          if (indexHelpHomeowner >= 0)
            this.textFemaTrainingHomeowner = this.listHelp[indexHelpHomeowner].answer;
        },
        error => console.log(error)
      );
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }
  public  redirectToEMRTraining() {
    this.router.navigate(['/trainingemr']);
  }
}
